<template>
  <div class="border border-medium-blue rounded-md p-6 w-full">
    <div class="">
      <div class="capitalize font-bold text-dark-blue text-xl">{{ $trans('app.package') + ' ' + payment.package }}</div>
      <div class="text-3xl text-medium-blue font-bold">{{ payment.amount / 100 }} €</div>
      <hr class="text-gray-300 my-4">
      <div class="text-gray-500 text-sm">{{ $trans('app.payment-made-on') + ' ' + formattedDate }}</div>
      <hr class="text-gray-300 my-4">
      <bubble-link href="#">{{ $trans('app.download-invoice') }}</bubble-link>
    </div>
  </div>
</template>

<script>
import {DateTime} from 'luxon'
import BubbleLink from "@/Components/BubbleLink";

export default {
  name: "InvoiceCard",
  components: {BubbleLink},
  props: {
    payment: {},
  },
  computed: {
    formattedDate() {
      return DateTime.fromSQL(this.payment.timestamp).toLocaleString(DateTime.DATETIME_MED)
    }
  }
}
</script>

<style scoped>

</style>
